import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabel } from 'primeng/floatlabel';
import { LocalStorageService } from '../../services/local-storage.service';
import { getRandomUsernames } from './usernames';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'login',
  imports: [
    CommonModule,
    ButtonModule,
    ReactiveFormsModule,
    InputTextModule,
    FloatLabel,
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
})
export class RegisterComponent {
  private storage = inject(LocalStorageService);
  private user = inject(UserService)
  usernames = signal<string[]>([]);
  username = new FormControl();
  router = inject(Router);

  log() {
    const value = this.username.value ?? '';
    this.storage.set('username', value);
    console.log('salvestatud:', value);
  }

  register() {
    if (!this.username.value) {
      console.warn('Username is empty. Please enter a valid username.');
      return;
    }
    this.user.registerUser(this.username.value).then((registeredUser) => {
      if (registeredUser) {
        console.log('User registered successfully:', registeredUser.nickname);
        this.router.navigate(['/jam']);
      } else {
        console.error('User registration failed.');
      }
    });

  }

  generateUsername() {
    const usernames = getRandomUsernames();
    this.usernames.set(usernames);
  }

  setUsername(username: string) {
    this.username.setValue(username);
  }
}
